import protocolConfigJson from "./protocol_config.json";

export const PROTOCOL_CONFIG = protocolConfigJson;

export const MQTT_PROTOCOL_CONFIG = PROTOCOL_CONFIG.mqtt;
export const WEBRTC_PROTOCOL_CONFIG = PROTOCOL_CONFIG.webrtc;
export const DATA_CHANNEL_CONFIG = PROTOCOL_CONFIG.dataChannel;
export const APP_MESSAGE_TYPES = PROTOCOL_CONFIG.appMessages;
